/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".inline.field[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{width:200px}\n/*# sourceMappingURL=pit-responsible-users.component.css.map*/"];
export { styles as styles };
